import { connect } from 'react-redux'
import React from 'react'
import { Form, Button, Message, Input, Segment, Header, Grid } from 'semantic-ui-react'
import {  updatePassword } from '../reducers/actions'

class ResetPassword extends React.Component {
     state = {
        user_id : '',
        password : '',
        repPassword : '', 
        canUpdate: false
     }

    updPassword (resetPasswordToken, password){
        this.props.onUpdatePassword({resetPasswordToken, password})
    }


     onSubmit = (e) => {
        e.preventDefault()
        this.updPassword(this.props.resetPasswordToken, this.state.password)
    }

    onPasswordChange = (e) => {
        this.setState({ password: e.target.value })
        if (this.state.repPassword === e.target.value)
            this.setState({ canUpdate: true})
        else this.setState({ canUpdate: false})
    }

    onRepeatPasswordChange = (e) => {
        this.setState({ repPassword: e.target.value })
        if (this.state.password === e.target.value)
            this.setState({ canUpdate: true})
        else this.setState({ canUpdate: false})
    }

        render() {
            const { error, user } = this.props
            const {  password,  repPassword, canUpdate} = this.state

            if (user!= null && user.password_updated == 1){
                return (
                    <Grid style={{ height: '100%', paddingTop: '4em' }} textAlign='center' verticalAlign='middle'>
                    <Grid.Column style={{ maxWidth: '450px' }}>
                        <Header as='h2'>{'Password aggiornata'}</Header>
                        {error ? <Message negative><p>{error}</p></Message> : ''}
                        <body>
                            <p> <a href='../'> Clicca qui per tornare al Login</a></p>
                        </body>
                    </Grid.Column>
                    </Grid>
                )
            }else 
              return (
                <Grid style={{ height: '100%', paddingTop: '4em' }} textAlign='center' verticalAlign='middle'>
                <Grid.Column style={{ maxWidth: '450px' }}>
                <Form onSubmit={this.onSubmit}>
                    <Header as='h2'>{'Reset Password'}</Header>
                    {error ? <Message negative><p>{error}</p></Message> : ''}
                  <body>
                            <Segment>
                                <Form.Input type="password" name='password' value={password} onChange={this.onPasswordChange}
                                placeholder="Password" icon='lock' iconPosition='left' />
                                <Form.Input type="password" name='repPassword'value={repPassword}  onChange={this.onRepeatPasswordChange}
                                placeholder="Repeat your password" icon='lock' iconPosition='left' />
                                <Button fluid primary disabled = {!canUpdate} type="submit">{'Aggiorna la password'}</Button>
                            </Segment>
                             <p> <a href='../'> Clicca qui per tornare al Login</a></p>
                         </body>
                    {<p>Non riesci ad accedere? Invia una mail a <a href='mailto:blackanswerlive@gmail.com'>blackanswerlive@gmail.com</a></p>}
                </Form>
                </Grid.Column>
                </Grid>
            )
        }
}

const mapStateToProps = (state) => ({
    user: state.user
})

const mapDispatchToProps = (dispatch, { socket }) => ({
    onUpdatePassword: ( {resetPasswordToken, password} ) => dispatch(updatePassword(socket, resetPasswordToken, password)),

})

export default  connect(
    mapStateToProps, 
    mapDispatchToProps
)(ResetPassword)



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js